import { Injectable } from '@angular/core';
import { ROOT_SCOPE_VARIABLES } from '@core/settings/root-scope.settings';
import { BehaviorSubject } from 'rxjs';
import { RootScopeService } from './upgraded-providers/wrappers/root-scope.service';

@Injectable({
  providedIn: 'root'
})
export class DomainService {
  _rootScopeChanges: any = {};
  private _apiUrl: string = '';

  apiUrl$ = new BehaviorSubject<string>(this._apiUrl);

  constructor(private _rootScopeService: RootScopeService) {
    this._rootScopeService.detectScopeChanges(ROOT_SCOPE_VARIABLES.CONFIG.SERVICES_DOMAINS);
    //subscribe to rootScopeSubject to detect desired changes
    this._rootScopeService.rootScopeObservable
      .subscribe(() => {
        this._rootScopeChanges = this._rootScopeService.getRootScope();
        if (this._rootScopeChanges?.app?.config?.servicesdomains) {
          this.onSetApiUrl(this._rootScopeChanges?.app?.config?.servicesdomains)
        }
      });
  }

  onSetApiUrl(domains: string[]) {
    const selectedApiUrl = domains?.[0] ?? '';
    if (!!selectedApiUrl) {
      this._apiUrl = selectedApiUrl;
      this.apiUrl$.next(selectedApiUrl);
    }
  }
}
